import axios from 'axios';
import { apiUrl } from './client';

// User + Role reads and writes. Unlike the config resources, User PATCH /
// DELETE-PIN address the user by id in the PATH (REST-style routes added
// later than the body-id convention used elsewhere).

interface AdminUser {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: { _id?: string; name?: string } | string;
  isActive?: boolean;
  [key: string]: any;
}

export const fetchUsers = async (companyId: string): Promise<AdminUser[]> => {
  const res = await axios.get(apiUrl(`User/${companyId}`));
  return res.data;
};

/** Fresh copy of one user (User/me/:id) — profile image, updatedAt, etc. */
export const fetchUserById = async (userId: string): Promise<AdminUser> => {
  const res = await axios.get(apiUrl(`User/me/${userId}`));
  return res.data;
};

export const addUser = async (data: Record<string, any>): Promise<any> => {
  const res = await axios.post(apiUrl('User'), data);
  return res.data;
};

/** PATCH fields on a user (id in the path, fields in the body). */
export const updateUser = async (userId: string, fields: Record<string, any>): Promise<any> => {
  const res = await axios.patch(apiUrl(`User/${userId}`), fields);
  return res.data;
};

export const deleteUser = async (id: string): Promise<void> => {
  await axios.delete(apiUrl('User'), { data: { id } });
};

/** Server-generated random PIN, emailed to the user; returns { pin } once. */
export const generateUserPin = async (userId: string): Promise<{ pin: string }> => {
  const res = await axios.post(apiUrl(`User/${userId}/pin/generate`));
  return res.data;
};

export const clearUserPin = async (userId: string): Promise<void> => {
  await axios.delete(apiUrl(`User/${userId}/pin`));
};

/**
 * All roles. Legacy GET /Role returns every company's roles (company
 * populated); tenant routes return only the tenant's — callers filter.
 */
export const fetchRoles = async (): Promise<any[]> => {
  const res = await axios.get(apiUrl('Role'));
  return res.data;
};
